const ES = {
    title: 'Vencimientos',
    table: {
        title: 'Listado de vencimientos',
        columns: {
            id: 'ID interno',
            client: 'Cliente',
            document: 'INE',
            lastFour: 'Últimos 4',
            balance: 'Saldo al cierre'
        },
        closingGroups: {
            53: 'Grupo de cierre 53',
            54: 'Grupo de cierre 54',
            55: 'Grupo de cierre 55',
            56: 'Grupo de cierre 56',
            openButton: 'Abrir',
            closeButton: 'Cerrar',
        },
        details: {
            cards: 'Tarjetas',
            totalBalance: 'Saldo total',
            closingDate: 'Fecha de cierre',
            expirationDate: 'Fecha de vencimiento',
        }
    },
};

export default ES;
